import * as React from 'react'
export function Website2LogoSVG({ title, className, ...props }) {
  return (
    <svg
      viewBox="0 0 110 61"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.897461 59.5344H2.34598C2.79322 59.5344 3.14407 59.4929 3.39875 59.4097C3.65344 59.3263 3.8562 59.209 4.00727 59.058C4.22025 58.845 4.38599 58.5588 4.50493 58.1992C4.62344 57.8401 4.68302 57.4041 4.68302 56.892C4.68302 56.1822 4.56663 55.6373 4.33365 55.2562C4.10089 54.8752 3.81748 54.6199 3.4845 54.4901C3.24386 54.3975 2.85662 54.3516 2.32279 54.3516H0.897461V59.5344ZM0 60.3353V53.5508H2.33704C2.86491 53.5508 3.26726 53.5833 3.54513 53.648C3.93364 53.7376 4.26535 53.8993 4.54003 54.134C4.89769 54.4363 5.16535 54.8229 5.3428 55.2933C5.52025 55.7638 5.60919 56.3012 5.60919 56.9061C5.60919 57.4214 5.54876 57.8778 5.42855 58.2757C5.30833 58.674 5.15408 59.0034 4.96556 59.264C4.77748 59.5249 4.57152 59.7298 4.34769 59.8795C4.12428 60.0293 3.85428 60.1425 3.5379 60.2195C3.22194 60.2966 2.85832 60.3353 2.4481 60.3353H0Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8281 60.3353V53.5508H16.7337V54.3516H12.7258V56.4293H16.479V57.2255H12.7258V59.5344H16.8909V60.3353H11.8281Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9678 59.5355H25.6569C25.9471 59.5355 26.1508 59.5248 26.268 59.5034C26.4746 59.4663 26.6474 59.4046 26.7861 59.3182C26.9252 59.2319 27.0393 59.1061 27.1289 58.941C27.2182 58.7761 27.2631 58.5855 27.2631 58.3693C27.2631 58.1165 27.198 57.8967 27.0684 57.7099C26.9391 57.5236 26.7591 57.3923 26.5295 57.3165C26.2995 57.2412 25.9684 57.2031 25.5367 57.2031H23.9678V59.5355ZM23.9678 56.4016H25.4348C25.8331 56.4016 26.1182 56.3752 26.291 56.3231C26.5195 56.2552 26.6912 56.1424 26.8069 55.9852C26.9229 55.8275 26.9808 55.6305 26.9808 55.3926C26.9808 55.1675 26.9265 54.9694 26.8186 54.7977C26.7108 54.6267 26.5565 54.5094 26.3557 54.4462C26.1552 54.3831 25.8112 54.3516 25.324 54.3516H23.9678V56.4016ZM23.0703 60.3353V53.5508H25.6156C26.1339 53.5508 26.5495 53.6197 26.8627 53.7567C27.1759 53.8942 27.4212 54.1053 27.5989 54.3908C27.7761 54.6761 27.8648 54.9746 27.8648 55.2861C27.8648 55.5763 27.7863 55.8495 27.6286 56.1055C27.4714 56.3614 27.2337 56.5682 26.9159 56.7255C27.3263 56.8457 27.6416 57.051 27.8625 57.341C28.0831 57.6312 28.1933 57.9736 28.1933 58.3683C28.1933 58.6863 28.1263 58.9817 27.9923 59.2549C27.8578 59.5276 27.692 59.7383 27.4946 59.8864C27.2969 60.0344 27.0495 60.1461 26.7518 60.2219C26.454 60.2976 26.0893 60.3353 25.6571 60.3353H23.0703Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1338 60.3353V54.3516H33.8984V53.5508H39.2759V54.3516H37.0316V60.3353H36.1338Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.5107 56.5451H55.4403C55.8508 56.5451 56.1716 56.5029 56.4033 56.418C56.6346 56.3329 56.8103 56.1976 56.9308 56.0108C57.051 55.824 57.1112 55.6212 57.1112 55.4023C57.1112 55.0814 56.9948 54.8176 56.7618 54.6106C56.5286 54.404 56.161 54.3008 55.658 54.3008H53.5107V56.5451ZM52.6133 60.3353V53.5508H55.6214C56.2261 53.5508 56.6861 53.6118 57.0005 53.7338C57.3152 53.8555 57.5667 54.0708 57.7548 54.3791C57.9431 54.6878 58.0369 55.0289 58.0369 55.4021C58.0369 55.8831 57.8814 56.2889 57.5699 56.6189C57.258 56.9493 56.7769 57.1589 56.1259 57.2485C56.3633 57.3625 56.5439 57.4753 56.6676 57.5863C56.9297 57.8272 57.1778 58.1278 57.4122 58.4889L58.5925 60.3353H57.4633L56.5654 58.9238C56.3033 58.5163 56.0873 58.2049 55.9178 57.9889C55.7478 57.7731 55.5961 57.6219 55.4616 57.5353C55.3276 57.4489 55.191 57.3889 55.0522 57.3548C54.9503 57.3334 54.7837 57.3227 54.5524 57.3227H53.5112V60.3353H52.6133Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.4297 60.3353V53.5508H69.3353V54.3516H65.3271V56.4293H69.0806V57.2255H65.3271V59.5344H69.4925V60.3353H64.4297Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.6719 60.3353V53.5508H76.5698V59.5344H79.9108V60.3353H75.6719Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.1016 60.3353H86.9994V53.5508H86.1016V60.3353Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.5742 60.3353V53.5508H98.4798V54.3516H94.4721V56.4293H98.2251V57.2255H94.4721V59.5344H98.637V60.3353H93.5742Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.898 60.3353V53.5508H109.475V54.3516H105.796V56.4523H108.98V57.2531H105.796V60.3353H104.898Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8928 49.0413L20.946 49.0661L20.9575 49.0413L20.793 49.0391L20.8928 49.0413Z"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0078125 34.5547H1.29442C1.3042 32.6642 1.33484 31.5478 1.38846 31.2023C1.48591 30.4091 1.81953 29.7768 2.38698 29.3153C2.95464 28.8514 3.76124 28.6172 4.80061 28.6172C5.54998 28.6172 6.39658 28.7936 7.34169 29.144V31.9508C6.8185 31.803 6.38934 31.7298 6.05041 31.7298C5.62593 31.7298 5.31423 31.8153 5.12083 31.9885C4.97891 32.1189 4.90742 32.3874 4.90742 32.7913L4.89487 34.5547H7.19786V37.6298H4.90742V49.0056H1.29442V37.6298H0.0078125V34.5547Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.51562 34.5565H12.6656V36.386C12.9944 35.6716 13.4342 35.1282 13.9848 34.756C14.5354 34.3845 15.1361 34.1992 15.7916 34.1992C16.2508 34.1992 16.7361 34.3235 17.2418 34.572L16.1252 37.6995C15.7027 37.4867 15.358 37.3831 15.0865 37.3831C14.5354 37.3831 14.0699 37.7275 13.6863 38.4158C13.3071 39.1054 13.1137 40.4578 13.1137 42.4727L13.1299 43.1733V49.0074H9.51562V34.5565Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0176 39.9951C21.4299 39.1146 21.8789 38.498 22.3623 38.1489C23.134 37.5921 24.0289 37.3125 25.0487 37.3125C25.9885 37.3125 26.8157 37.5602 27.5276 38.0597C28.2395 38.5566 28.7176 39.2023 28.9595 39.9951H21.0176ZM32.5706 42.1291C32.5706 39.7471 31.8567 37.829 30.4271 36.3782C28.9999 34.9262 27.1463 34.1992 24.8648 34.1992C22.7175 34.1992 20.9307 34.9267 19.5071 36.3794C18.0826 37.8329 17.3711 39.6612 17.3711 41.8605C17.3711 44.0095 18.0826 45.7957 19.5092 47.2225C20.9335 48.6495 22.7813 49.3634 25.046 49.3634C26.509 49.3634 27.7705 49.1046 28.8341 48.587C29.8952 48.0697 30.8076 47.2714 31.5697 46.1929L28.515 44.7591C27.5401 45.7065 26.3754 46.1804 25.0222 46.1804C23.8877 46.1804 22.9541 45.8782 22.2247 45.2701C21.4932 44.6642 21.0439 43.8465 20.8739 42.8197H32.5574L32.5706 42.1291Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.4443 39.9951C38.8552 39.1146 39.3041 38.498 39.7892 38.1489C40.5586 37.5921 41.4527 37.3125 42.4746 37.3125C43.4146 37.3125 44.2399 37.5602 44.9529 38.0597C45.6657 38.5566 46.1425 39.2023 46.3863 39.9951H38.4443ZM49.9959 42.1291C49.9959 39.7471 49.2825 37.829 47.8529 36.3782C46.4235 34.9262 44.5699 34.1992 42.2903 34.1992C40.1427 34.1992 38.3556 34.9267 36.932 36.3794C35.5077 37.8329 34.7969 39.6612 34.7969 41.8605C34.7969 44.0095 35.5077 45.7957 36.935 47.2225C38.3609 48.6495 40.205 49.3634 42.4722 49.3634C43.9363 49.3634 45.1963 49.1046 46.2587 48.587C47.3214 48.0697 48.2336 47.2714 48.9961 46.1929L45.9399 44.7591C44.9661 45.7065 43.7993 46.1804 42.445 46.1804C41.312 46.1804 40.3816 45.8782 39.649 45.2701C38.9175 44.6642 38.4707 43.8465 38.2999 42.8197H49.9831L49.9959 42.1291Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.6099 38.6892C63.3638 39.4688 63.7397 40.4866 63.7397 41.7424C63.7397 43.0222 63.3638 44.0594 62.6099 44.8501C61.8593 45.6409 60.9091 46.0354 59.7674 46.0354C58.6591 46.0354 57.7263 45.635 56.9705 44.8299C56.2135 44.0248 55.8369 43.0001 55.8369 41.7524C55.8369 40.5179 56.2078 39.5028 56.9527 38.7113C57.6961 37.9194 58.6305 37.5234 59.7555 37.5234C60.9061 37.5234 61.8593 37.9132 62.6099 38.6892ZM63.5942 36.1515C62.9489 35.5015 62.2423 35.013 61.4789 34.6864C60.7161 34.3602 59.8965 34.1977 59.0299 34.1977C57.1376 34.1977 55.5312 34.9092 54.2069 36.3313C52.8852 37.7541 52.2227 39.5796 52.2227 41.8052C52.2227 43.9524 52.9056 45.7509 54.2733 47.1937C55.6406 48.6399 57.2627 49.3618 59.1357 49.3618C59.9699 49.3618 60.7448 49.2131 61.4597 48.9175C62.1723 48.6212 62.8857 48.1392 63.5942 47.466V49.0058H67.2102V28.9766H63.5942V36.1515Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.0481 38.7598C80.7856 39.5353 81.156 40.5417 81.156 41.7804C81.156 43.0194 80.7798 44.0339 80.0288 44.8215C79.2758 45.61 78.3356 46.0041 77.2026 46.0041C76.0715 46.0041 75.1355 45.6156 74.3966 44.8352C73.6575 44.0568 73.2881 43.0373 73.2881 41.7804C73.2881 40.5585 73.6619 39.5575 74.4087 38.773C75.1572 37.9904 76.0915 37.5977 77.216 37.5977C78.366 37.5977 79.3092 37.9853 80.0481 38.7598ZM72.1556 36.1624C70.5034 37.6618 69.6758 39.5422 69.6758 41.7946C69.6758 43.8986 70.4088 45.6857 71.8718 47.1576C73.3333 48.6293 75.0999 49.3642 77.1694 49.3642C78.5737 49.3642 79.8586 49.0306 81.0259 48.361C82.1935 47.6951 83.115 46.7704 83.7895 45.5872C84.4663 44.4016 84.805 43.1286 84.805 41.7667C84.805 40.4173 84.4695 39.1575 83.798 37.9905C83.1246 36.8243 82.191 35.8999 80.9931 35.2211C79.7939 34.5396 78.5175 34.1992 77.1573 34.1992C75.2718 34.1992 73.6047 34.855 72.1556 36.1624Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.2656 34.5565H90.8771V36.2431C91.501 35.558 92.1912 35.0456 92.9535 34.7069C93.714 34.3688 94.544 34.1992 95.4431 34.1992C96.3497 34.1992 97.1693 34.4226 97.9004 34.8699C98.6306 35.3167 99.22 35.966 99.6625 36.8237C100.243 35.966 100.952 35.3167 101.792 34.8699C102.633 34.4226 103.552 34.1992 104.549 34.1992C105.583 34.1992 106.489 34.4392 107.272 34.9167C108.056 35.3945 108.619 36.0158 108.962 36.7856C109.307 37.556 109.476 38.8071 109.476 40.541V49.0074H105.865V41.7046C105.865 40.0737 105.657 38.9699 105.243 38.3914C104.83 37.8135 104.21 37.5246 103.382 37.5246C102.754 37.5246 102.187 37.7014 101.689 38.0544C101.19 38.4067 100.819 38.8954 100.577 39.5152C100.334 40.139 100.212 41.1359 100.212 42.5106V49.0074H96.6006V42.0354C96.6006 40.7484 96.5042 39.8163 96.3116 39.2375C96.1163 38.6612 95.8278 38.2316 95.4406 37.9497C95.0535 37.6654 94.5852 37.5246 94.0357 37.5246C93.4231 37.5246 92.8699 37.7031 92.3695 38.0609C91.8699 38.4182 91.4961 38.9186 91.2495 39.562C91.0025 40.2052 90.8771 41.2203 90.8771 42.6054V49.0074H87.2656V34.5565Z"
        fill="#184895"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.70312 23.5859L20.7409 29.4981C21.1032 28.5262 21.5213 27.5926 21.9868 26.7011L6.70312 23.5859Z"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.5451 16.3267C34.5885 16.3167 34.6321 16.3088 34.677 16.2979L28.5859 1.28125L31.7221 17.2656C32.5889 16.8882 33.4817 16.5835 34.4024 16.3579L34.5451 16.3267Z"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.0384 17.5779C31.1982 17.5026 31.3578 17.4272 31.5197 17.3545L22.6445 3.78906L28.7939 18.8847C29.4727 18.4206 30.1727 18.0049 30.9001 17.6447L31.0384 17.5779Z"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.795 19.6132C28.0633 19.4015 28.3409 19.1986 28.623 19.0026L17.293 7.43359L26.2054 20.9973C26.6728 20.5426 27.1594 20.1154 27.6624 19.7135L27.795 19.6132Z"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9291 22.3497C25.2895 21.9327 25.6633 21.5338 26.0501 21.1502L12.7422 12.0703L23.9912 23.5151C24.2548 23.1627 24.5261 22.8223 24.8063 22.4936L24.9291 22.3497Z"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.2704 23.4968L63.5019 12.0716L50.214 21.1382C50.1614 21.0842 50.1072 21.0297 50.0519 20.9765L58.9521 7.43452L47.6352 18.9891C47.5765 18.9474 47.5157 18.9074 47.4565 18.8661L53.5997 3.7896L44.7308 17.3442C44.6625 17.3118 44.5925 17.2814 44.5201 17.2505L47.6525 1.27937L41.5669 16.2899C41.486 16.2733 41.4063 16.2535 41.3248 16.2356L41.3412 0L38.2524 15.9018C38.2456 15.9018 38.2399 15.901 38.2316 15.9001H38.1992C39.3939 15.9152 40.5635 16.0603 41.6973 16.3265L41.8397 16.3571C43.0048 16.6405 44.1265 17.055 45.2056 17.5784L45.3425 17.6452C46.434 18.1859 47.4727 18.8495 48.4518 19.6142L48.5812 19.7144C49.5595 20.4914 50.4731 21.3755 51.3151 22.351L51.4378 22.4948C52.2704 23.4746 53.0272 24.5491 53.7006 25.6966L53.8125 25.8876C53.9029 26.0446 53.9908 26.2032 54.0753 26.3615L54.101 26.3442L67.0775 17.5259"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8271 23.7365L9.16406 17.5273L22.1633 26.3625C22.2505 26.2046 22.338 26.047 22.4276 25.8902L22.5405 25.6982"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.9023 0L34.9177 16.2431C35.9189 16.0346 36.9449 15.9173 37.993 15.9022L34.9023 0Z"
        fill="#BD252C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.5439 23.5859L54.2885 26.6928L54.2578 26.7011C54.7304 27.6058 55.1523 28.5528 55.5202 29.537L55.3729 29.5375L55.3802 29.5483L55.404 29.5375L55.5525 29.537C55.5451 29.5183 55.5385 29.5017 55.531 29.4843L69.5439 23.5859Z"
        fill="#BD252C"
      />
    </svg>
  )
}
export default Website2LogoSVG
